import rill from "rill";

import widgetsController from "./widgets.controller";
import { checkOrganizationSectionPermission } from "../../../middleware/ensure-coach-permissions";

const Widgets = (app) => {
  app.at(
    "/widgets/*",
    rill().setup((app) => {
      app.get(
        "/",
        (ctx, next) =>
          checkOrganizationSectionPermission(
            ctx,
            next,
            ["Widgets"],
            "/coaching-portal/athletes"
          ),
        widgetsController
      );
    })
  );
};

export default Widgets;
